import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const BasicTooltip = (props) => {
    const popover = (
        <Popover>
            <Popover.Header as="h3">{props.header}</Popover.Header>
            <Popover.Body>{props.body}</Popover.Body>
        </Popover>
    );

    return (
        <React.Fragment>
            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popover}>
                <i className="dripicons-information">&nbsp;&nbsp;</i>
            </OverlayTrigger>
        </React.Fragment>
    );
};

export { BasicTooltip };
